import classNames from 'classnames/bind';
import React, { Component } from 'react';
import {
  Button, Col, OverlayTrigger, Row, Tooltip,
} from 'react-bootstrap';
import { FaPlay } from 'react-icons/fa';
import imgDelete from '../../../assets/images/delete.svg';
import imgEditStory from '../../../assets/images/edit-story.png';
import styles from '../Characters/Characters.scss';
import { PreviewImg } from '../Characters/PreviewImg';
import { VideoModal } from '../VideoLibraryPage/VideoModal/VideoModal';
import { LocationsDelete } from './LocationsDelete';

const cs = classNames.bind(styles);

export class LocationsTableRow extends Component {
  constructor(props, ...args) {
    super(props, ...args);
    this.state = {
      modalDeleteLocationsShow: false,
      isVideoModalShown: false,
    };
  }

  static imageAlias(obj) {
    return obj.image ? obj.image.alias : null;
  }

  handleVideoPreviewClick = () => {
    this.setState({ isVideoModalShown: true });
  };

  render() {
    const {
      obj, args, disabled,
    } = this.props;
    const { modalDeleteLocationsShow, isVideoModalShown } = this.state;

    const modalDeleteLocationsClose = () => {
      this.setState({ modalDeleteLocationsShow: false });
      args.update();
    };

    const isDeleteButtonDisabled = disabled
        || args.deleteDisabled
        || obj.branches_count > 0
        || obj.stories_count > 0
        || obj.isDefault;
    return (
      <Row className="py-2 border-bottom">
        <Col md={1} className="text-center">
          {obj.isDefault}
          <div className={cs(obj.isDefault === true ? 'checked' : null, 'circleBox')} />
        </Col>
        <Col md={4}>
          {obj.title}
        </Col>
        <Col md={3}>
          {LocationsTableRow.imageAlias(obj)}
        </Col>
        <Col md={2} className="d-flex justify-content-start align-items-center">
          <PreviewImg
            className="PreviewImg-36"
            style={{ maxWidth: '36px', maxHeight: '36px', overflow: 'hidden' }}
            character={obj}
          />
          {obj?.video && (
            <Button
              variant="outline-primary"
              size="sm"
              className="ml-2 py-0"
              style={{ height: '36px' }}
              onClick={this.handleVideoPreviewClick}
            >
              <FaPlay size={12} />
            </Button>
          )}
        </Col>
        <Col md={2} className="text-right">
          <OverlayTrigger
            overlay={(
              <Tooltip id="tooltip-top">
                Edit
              </Tooltip>
            )}
          >
            <Button
              disabled={disabled || args.editDisabled}
              onClick={() => {
                args.onStartEdit(obj);
              }}
              variant="secondary"
              size="sm"
              className="mx-1"
            >
              <img src={imgEditStory} className="btnImg" alt="Edit" />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={(
              <Tooltip id="tooltip-top">
                Delete
              </Tooltip>
            )}
          >
            <Button
              disabled={isDeleteButtonDisabled}
              onClick={() => this.setState({ modalDeleteLocationsShow: true })}
              variant="secondary"
              size="sm"
              className="mx-1"
            >
              <img src={imgDelete} className="btnImg" alt="Delete" />
            </Button>
          </OverlayTrigger>
        </Col>
        {modalDeleteLocationsShow === true && (
          <LocationsDelete
            show={modalDeleteLocationsShow}
            onHide={modalDeleteLocationsClose}
            obj={obj}
            args={args}
          />
        )}
        {isVideoModalShown && (
          <VideoModal
            video={obj.video}
            videoSettings={obj.videoSettings}
            isVisible={isVideoModalShown}
            onClose={() => this.setState({ isVideoModalShown: false })}
          />
        )}
      </Row>
    );
  }
}
